import React from "react";
import {Select as MuiSelect, SelectProps} from "@mui/material";

export type SelectType = SelectProps & {
  fullWidth?: boolean;
};
export const Select = ({fullWidth, children, sx, ...props}: SelectType) => {
  return (
    <MuiSelect
      sx={{
        borderRadius: "8px",
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiSelect>
  );
};
